export const PHONE_DISPLAY = "+36 20 243 5165";
export const PHONE_TEL = "tel:+36202435165";

export const GOOGLE_ADS_ID = "AW-18526118248";
// Google Ads konverziós címkék – a "send_to" végén lévő azonosítót kell beírni
// (Google Ads → Célok → Konverziók → címke részletei). Pl. "AbCdEfGh123".
export const CONVERSION_LABELS = {
  phone: "24dSCLaK8KIdEOjC-IFF",
  form: "24dSCLaK8KIdEOjC-IFF",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/7464689/pexels-photo-7464689.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  process1: "https://images.unsplash.com/photo-1670175035057-eec020c03eb9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxqdW5rJTIwcmVtb3ZhbCUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3ODc2OTU3Njh8MA&ixlib=rb-4.1.0&q=85",
  process2: "https://images.unsplash.com/photo-1613199928741-1a757b32ffc4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxqdW5rJTIwcmVtb3ZhbCUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3ODc2OTU3Njh8MA&ixlib=rb-4.1.0&q=85",
  process3: "https://images.pexels.com/photos/3284980/pexels-photo-3284980.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
